import _slicedToArray from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["MenuItemProps", "className", "label", "leftIcon", "rightIcon"],
    _excluded2 = ["parentMenuOpen", "label", "rightIcon", "leftIcon", "children", "className", "tabIndex", "ContainerProps", "MenuProps"],
    _excluded3 = ["ref"],
    _excluded4 = ["menuItemsData", "onClick", "ButtonProps", "MenuProps"];

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { jsxs as $dw2me$jsxs, jsx as $dw2me$jsx } from "react/jsx-runtime";
import $dw2me$muimaterialMenu from "@mui/material/Menu";
import { forwardRef as $dw2me$forwardRef, useRef as $dw2me$useRef, useState as $dw2me$useState, useImperativeHandle as $dw2me$useImperativeHandle } from "react";
import $dw2me$muimaterialMenuItem from "@mui/material/MenuItem";
import { styled as $dw2me$styled } from "@mui/material/styles";
import $dw2me$muimaterialTypography from "@mui/material/Typography";
import $dw2me$muisystemBox from "@mui/system/Box";
import $dw2me$muimaterialSvgIcon from "@mui/material/SvgIcon";
import $dw2me$muimaterialButton from "@mui/material/Button";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}

var $4a0ad0bf42c271a8$exports = {};
var $ad513b13aee61650$exports = {};
$parcel$export($ad513b13aee61650$exports, "ContextMenu", function () {
  return $ad513b13aee61650$export$8dc6765e8be191c7;
});
var $80b2acfbe3fcf9bd$exports = {};
$parcel$export($80b2acfbe3fcf9bd$exports, "nestedMenuItemsFromObject", function () {
  return $80b2acfbe3fcf9bd$export$fa07f0a23a9d3fdc;
});
var $72864715d956ea8e$exports = {};
$parcel$export($72864715d956ea8e$exports, "IconMenuItem", function () {
  return $72864715d956ea8e$export$29aa74ef483b19fe;
});
var $72864715d956ea8e$var$StyledMenuItem = (0, $dw2me$styled)((0, $dw2me$muimaterialMenuItem))({
  display: "flex",
  justifyContent: "space-between",
  paddingLeft: "4px",
  paddingRight: "4px"
});
var $72864715d956ea8e$var$StyledTypography = (0, $dw2me$styled)((0, $dw2me$muimaterialTypography))({
  paddingLeft: "8px",
  paddingRight: "8px",
  textAlign: "left"
});
var $72864715d956ea8e$var$FlexBox = (0, $dw2me$styled)((0, $dw2me$muisystemBox))({
  display: "flex"
});
var $72864715d956ea8e$export$29aa74ef483b19fe = /*#__PURE__*/(0, $dw2me$forwardRef)(function IconMenuItem(_ref, ref) {
  var MenuItemProps = _ref.MenuItemProps,
      className = _ref.className,
      label = _ref.label,
      leftIcon = _ref.leftIcon,
      rightIcon = _ref.rightIcon,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/(0, $dw2me$jsxs)($72864715d956ea8e$var$StyledMenuItem, _objectSpread(_objectSpread(_objectSpread({}, MenuItemProps), {}, {
    ref: ref,
    className: className
  }, props), {}, {
    children: [/*#__PURE__*/(0, $dw2me$jsxs)($72864715d956ea8e$var$FlexBox, {
      children: [leftIcon, /*#__PURE__*/(0, $dw2me$jsx)($72864715d956ea8e$var$StyledTypography, {
        children: label
      })]
    }), rightIcon]
  }));
});
var $fbbfd8893e0b22a2$exports = {};
$parcel$export($fbbfd8893e0b22a2$exports, "NestedMenuItem", function () {
  return $fbbfd8893e0b22a2$export$a49133e888f99d9b;
});

var $c842cdd09bc7bdb3$export$6172d85aadfc9b96 = function $c842cdd09bc7bdb3$export$6172d85aadfc9b96(props) {
  return /*#__PURE__*/(0, $dw2me$jsx)((0, $dw2me$muimaterialSvgIcon), _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0, $dw2me$jsx)("path", {
      d: "M9.29 6.71c-.39.39-.39 1.02 0 1.41L13.17 12l-3.88 3.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41L10.7 6.7c-.38-.38-1.02-.38-1.41.01z"
    })
  }));
};

var $fbbfd8893e0b22a2$export$a49133e888f99d9b = /*#__PURE__*/(0, $dw2me$forwardRef)(function NestedMenuItem(props, ref) {
  var parentMenuOpen = props.parentMenuOpen,
      label = props.label,
      _props$rightIcon = props.rightIcon,
      rightIcon = _props$rightIcon === void 0 ? /*#__PURE__*/(0, $dw2me$jsx)((0, $c842cdd09bc7bdb3$export$6172d85aadfc9b96), {}) : _props$rightIcon,
      _props$leftIcon = props.leftIcon,
      leftIcon = _props$leftIcon === void 0 ? null : _props$leftIcon,
      children = props.children,
      className = props.className,
      tabIndexProp = props.tabIndex,
      _props$ContainerProps = props.ContainerProps,
      ContainerPropsProp = _props$ContainerProps === void 0 ? {} : _props$ContainerProps,
      MenuProps = props.MenuProps,
      MenuItemProps = _objectWithoutProperties(props, _excluded2);

  var containerRefProp = ContainerPropsProp.ref,
      ContainerProps = _objectWithoutProperties(ContainerPropsProp, _excluded3);

  var menuItemRef = (0, $dw2me$useRef)(null);
  (0, $dw2me$useImperativeHandle)(ref, function () {
    return menuItemRef.current;
  }); // eslint-disable-line @typescript-eslint/no-non-null-assertion

  var containerRef = (0, $dw2me$useRef)(null);
  (0, $dw2me$useImperativeHandle)(containerRefProp, function () {
    return containerRef.current;
  });
  var menuContainerRef = (0, $dw2me$useRef)(null);

  var _ref2 = (0, $dw2me$useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      isSubMenuOpen = _ref3[0],
      setIsSubMenuOpen = _ref3[1];

  var handleMouseEnter = function handleMouseEnter(e) {
    setIsSubMenuOpen(true);
    if (ContainerProps.onMouseEnter) ContainerProps.onMouseEnter(e);
  };

  var handleMouseLeave = function handleMouseLeave(e) {
    setIsSubMenuOpen(false);
    if (ContainerProps.onMouseLeave) ContainerProps.onMouseLeave(e);
  }; // Check if any immediate children are active


  var isSubmenuFocused = function isSubmenuFocused() {
    var _containerRef$current, _containerRef$current2;

    var active = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.ownerDocument.activeElement) !== null && _containerRef$current !== void 0 ? _containerRef$current : null; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    var _iterator = _createForOfIteratorHelper(menuContainerRef.current.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        if (child === active) return true;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return false;
  };

  var handleFocus = function handleFocus(e) {
    if (e.target === containerRef.current) setIsSubMenuOpen(true);
    if (ContainerProps.onFocus) ContainerProps.onFocus(e);
  };

  var handleKeyDown = function handleKeyDown(e) {
    var _containerRef$current3, _containerRef$current4;

    if (e.key === "Escape") return;
    if (isSubmenuFocused()) e.stopPropagation();
    var active = (_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.ownerDocument.activeElement;
    if (e.key === "ArrowLeft" && isSubmenuFocused()) (_containerRef$current4 = containerRef.current) === null || _containerRef$current4 === void 0 ? void 0 : _containerRef$current4.focus();

    if (e.key === "ArrowRight" && e.target === containerRef.current && e.target === active) {
      var _menuContainerRef$cur;

      var firstChild = (_menuContainerRef$cur = menuContainerRef.current) === null || _menuContainerRef$cur === void 0 ? void 0 : _menuContainerRef$cur.children[0];
      firstChild === null || firstChild === void 0 ? void 0 : firstChild.focus();
    }
  };

  var open = isSubMenuOpen && parentMenuOpen; // Root element must have a `tabIndex` attribute for keyboard navigation

  var tabIndex;
  if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  return /*#__PURE__*/(0, $dw2me$jsxs)("div", _objectSpread(_objectSpread({}, ContainerProps), {}, {
    ref: containerRef,
    onFocus: handleFocus,
    tabIndex: tabIndex,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/(0, $dw2me$jsx)((0, $72864715d956ea8e$export$29aa74ef483b19fe), {
      MenuItemProps: MenuItemProps,
      className: className,
      ref: menuItemRef,
      leftIcon: leftIcon,
      rightIcon: rightIcon,
      label: label
    }), /*#__PURE__*/(0, $dw2me$jsx)((0, $dw2me$muimaterialMenu), _objectSpread(_objectSpread({
      // Set pointer events to 'none' to prevent the invisible Popover div
      // from capturing events for clicks and hovers
      style: {
        pointerEvents: "none"
      },
      anchorEl: menuItemRef.current,
      anchorOrigin: {
        horizontal: "right",
        vertical: "top"
      },
      transformOrigin: {
        horizontal: "left",
        vertical: "top"
      },
      open: open,
      autoFocus: false,
      disableAutoFocus: true,
      disableEnforceFocus: true,
      onClose: function onClose() {
        setIsSubMenuOpen(false);
      }
    }, MenuProps), {}, {
      children: /*#__PURE__*/(0, $dw2me$jsx)("div", {
        ref: menuContainerRef,
        style: {
          pointerEvents: "auto"
        },
        children: children
      })
    }))]
  }));
});
$fbbfd8893e0b22a2$export$a49133e888f99d9b.displayName = "NestedMenuItem";

function $80b2acfbe3fcf9bd$export$fa07f0a23a9d3fdc(_ref4) {
  var items = _ref4.menuItemsData,
      isOpen = _ref4.isOpen,
      handleClose = _ref4.handleClose;
  return items.map(function (item) {
    var leftIcon = item.leftIcon,
        rightIcon = item.rightIcon,
        label = item.label,
        items = item.items,
        callback = item.callback,
        sx = item.sx,
        disabled = item.disabled;
    if (items && items.length > 0) // Recurse deeper
      return /*#__PURE__*/(0, $dw2me$jsx)((0, $fbbfd8893e0b22a2$export$a49133e888f99d9b), {
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        label: label,
        parentMenuOpen: isOpen,
        sx: sx,
        disabled: disabled,
        children: $80b2acfbe3fcf9bd$export$fa07f0a23a9d3fdc({
          handleClose: handleClose,
          isOpen: isOpen,
          menuItemsData: items
        })
      }, label);else // No children elements, return MenuItem
      return /*#__PURE__*/(0, $dw2me$jsx)((0, $72864715d956ea8e$export$29aa74ef483b19fe), {
        leftIcon: leftIcon,
        rightIcon: rightIcon,
        label: label,
        onClick: function onClick(event) {
          handleClose();
          callback && callback(event, item);
        },
        sx: sx,
        disabled: disabled
      }, label);
  });
}

var $ad513b13aee61650$export$8dc6765e8be191c7 = /*#__PURE__*/(0, $dw2me$forwardRef)(function ContextMenu(_ref5, ref) {
  var children = _ref5.children,
      menuItems = _ref5.menuItems,
      menuItemsData = _ref5.menuItemsData;
  var wrapperRef = ref !== null && ref !== void 0 ? ref : (0, $dw2me$useRef)(null);

  var _ref6 = (0, $dw2me$useState)(null),
      _ref7 = _slicedToArray(_ref6, 2),
      menuPosition = _ref7[0],
      setMenuPosition = _ref7[1];

  var _ref8 = (0, $dw2me$useState)(null),
      _ref9 = _slicedToArray(_ref8, 2),
      mouseDownPosition = _ref9[0],
      setMouseDownPosition = _ref9[1];

  var handleItemClick = function handleItemClick() {
    return setMenuPosition(null);
  };

  var handleMouseDown = function handleMouseDown(e) {
    if (menuPosition !== null) setMenuPosition(null);
    if (e.button !== 2) return;
    var wrapperBounds = wrapperRef.current.getBoundingClientRect();
    if (e.clientX < wrapperBounds.left || e.clientX > wrapperBounds.right || e.clientY < wrapperBounds.top || e.clientY > wrapperBounds.bottom) return;
    setMouseDownPosition({
      left: e.clientX,
      top: e.clientY
    });
  };

  var handleMouseUp = function handleMouseUp(e) {
    var top = e.clientY;
    var left = e.clientX;
    if (mouseDownPosition === null) return;
    if (mouseDownPosition.top === top && mouseDownPosition.left === left) setMenuPosition({
      left: e.clientX,
      top: e.clientY
    });
  };

  var menuContents = menuItems !== null && menuItems !== void 0 ? menuItems : menuItemsData && (0, $80b2acfbe3fcf9bd$export$fa07f0a23a9d3fdc)({
    handleClose: handleItemClick,
    isOpen: !!menuPosition,
    menuItemsData: menuItemsData
  });
  return /*#__PURE__*/(0, $dw2me$jsxs)("div", {
    ref: wrapperRef,
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    onMouseDown: handleMouseDown,
    onMouseUp: handleMouseUp,
    children: [menuPosition && /*#__PURE__*/(0, $dw2me$jsx)((0, $dw2me$muimaterialMenu), {
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      open: !!menuPosition,
      onClose: function onClose() {
        return setMenuPosition(null);
      },
      anchorReference: "anchorPosition",
      anchorPosition: menuPosition,
      children: menuContents
    }), children]
  });
});
var $0967ca77ae60d41a$exports = {};
$parcel$export($0967ca77ae60d41a$exports, "NestedDropdown", function () {
  return $0967ca77ae60d41a$export$84d8e229d5f1c7fc;
});

var $4a9ea60dc2f34ae6$export$4e3778eb35f54199 = function $4a9ea60dc2f34ae6$export$4e3778eb35f54199(props) {
  return /*#__PURE__*/(0, $dw2me$jsx)((0, $dw2me$muimaterialSvgIcon), _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0, $dw2me$jsx)("path", {
      d: "M8.12 9.29 12 13.17l3.88-3.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-4.59 4.59c-.39.39-1.02.39-1.41 0L6.7 10.7a.9959.9959 0 0 1 0-1.41c.39-.38 1.03-.39 1.42 0z"
    })
  }));
};

var $0967ca77ae60d41a$export$84d8e229d5f1c7fc = /*#__PURE__*/(0, $dw2me$forwardRef)(function NestedDropdown(props, ref) {
  var _data$items, _data$label;

  var _ref10 = (0, $dw2me$useState)(null),
      _ref11 = _slicedToArray(_ref10, 2),
      anchorEl = _ref11[0],
      setAnchorEl = _ref11[1];

  var open = Boolean(anchorEl);

  var data = props.menuItemsData,
      onClick = props.onClick,
      ButtonProps = props.ButtonProps,
      MenuProps = props.MenuProps,
      rest = _objectWithoutProperties(props, _excluded4);

  var handleClick = function handleClick(e) {
    setAnchorEl(e.currentTarget);
    onClick && onClick(e);
  };

  var handleClose = function handleClose() {
    return setAnchorEl(null);
  };

  var menuItems = (0, $80b2acfbe3fcf9bd$export$fa07f0a23a9d3fdc)({
    handleClose: handleClose,
    isOpen: open,
    menuItemsData: (_data$items = data === null || data === void 0 ? void 0 : data.items) !== null && _data$items !== void 0 ? _data$items : []
  });
  return /*#__PURE__*/(0, $dw2me$jsxs)("div", _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: [/*#__PURE__*/(0, $dw2me$jsx)((0, $dw2me$muimaterialButton), _objectSpread(_objectSpread({
      onClick: handleClick,
      endIcon: /*#__PURE__*/(0, $dw2me$jsx)((0, $4a9ea60dc2f34ae6$export$4e3778eb35f54199), {})
    }, ButtonProps), {}, {
      children: (_data$label = data === null || data === void 0 ? void 0 : data.label) !== null && _data$label !== void 0 ? _data$label : "Menu"
    })), /*#__PURE__*/(0, $dw2me$jsx)((0, $dw2me$muimaterialMenu), _objectSpread(_objectSpread({
      anchorEl: anchorEl,
      open: open,
      onClose: handleClose
    }, MenuProps), {}, {
      children: menuItems
    }))]
  }));
});
$parcel$exportWildcard($4a0ad0bf42c271a8$exports, $ad513b13aee61650$exports);
$parcel$exportWildcard($4a0ad0bf42c271a8$exports, $72864715d956ea8e$exports);
$parcel$exportWildcard($4a0ad0bf42c271a8$exports, $0967ca77ae60d41a$exports);
$parcel$exportWildcard($4a0ad0bf42c271a8$exports, $fbbfd8893e0b22a2$exports);
$parcel$exportWildcard($4a0ad0bf42c271a8$exports, $80b2acfbe3fcf9bd$exports);
var $f84fb5b0231b4d1f$exports = {};
export { $ad513b13aee61650$export$8dc6765e8be191c7 as ContextMenu, $72864715d956ea8e$export$29aa74ef483b19fe as IconMenuItem, $0967ca77ae60d41a$export$84d8e229d5f1c7fc as NestedDropdown, $fbbfd8893e0b22a2$export$a49133e888f99d9b as NestedMenuItem, $80b2acfbe3fcf9bd$export$fa07f0a23a9d3fdc as nestedMenuItemsFromObject };